import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const config: Configuration = {
  auth: {
    authority:
      "https://login.microsoftonline.com/86cbe1bb-213f-4271-b174-bd59d03c87a3",
    clientId: "9f716def-2f0c-4583-8986-69ddde54d884",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const authProvider = new PublicClientApplication(config);
